import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-Overlay.vue?vue&type=template&id=2ab00a69&scoped=true&"
var script = {}
import style0 from "./comp_CategoriesMegaMenu-Overlay.vue?vue&type=style&index=0&id=2ab00a69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab00a69",
  null
  
)

export default component.exports